// Central product facts. Read from this file (or src/config/pricing.ts) anywhere
// the marketing site needs to show a count, plan name, or price. Do not hardcode
// these values in pages or i18n strings - import from here so a single change
// propagates across the whole site.

export { PRICING, PRICING_CONFIG } from "./pricing";
import { PRICING } from "./pricing";

export const PRODUCT_FACTS = {
  documentCount: 40,
  documentCountLabel: "40+",
  aiToolCount: 11,
  aiToolCountLabel: "11",
  riskPlatformCount: 1,
  planNames: {
    free: PRICING.free.name,
    docPack: PRICING.docPack.name,
    aiPlus: PRICING.aiPlus.name,
    pro: PRICING.pro.name,
    bundle: PRICING.bundle.name,
  },
  featureNames: {
    auditRoom: "Audit Room",
    riskPlatform: "Risk Management Platform",
    aiAssistant: "AI Assistant",
    vendorChecker: "Vendor Security Checker",
    soaGenerator: "SoA Generator",
    gapAnalysis: "Gap Analysis",
    readinessCheck: "Readiness Check",
    internalAudit: "Internal Audit Checklist",
    roadmap: "Implementation Roadmap",
    scopeBuilder: "ISMS Scope Builder",
    assetInventory: "Asset Inventory",
    annexA: "Annex A Selector",
    supplierRisk: "Supplier Risk Manager",
    rtoRpo: "RTO/RPO Helper",
  },
} as const;

export const PRIMARY_CTAS = {
  home:            { label: "Get the Document Pack", href: "/documents" },
  documents:       { label: "Get the Document Pack", href: "/documents#pricing" },
  aiAssistant:     { label: "Start chatting free",   href: "/ai-assistant" },
  riskManagement:  { label: "Open the Risk Platform", href: "/risk-management" },
  auditRoom:       { label: "Open Audit Room",       href: "/audit-room" },
  tools:           { label: "Browse tools",          href: "/tools" },
  vendorChecker:   { label: "Run a scan",            href: "/vendor-checker" },
  readinessCheck:  { label: "Start the check",       href: "/readiness-check" },
  gapAnalysis:     { label: "Start gap analysis",    href: "/tools/gap-analysis" },
  templates:       { label: "Get templates",         href: "/documents" },
  pricing:         { label: "Choose a plan",         href: "/pricing" },
} as const;

export type ProductFactKey = keyof typeof PRODUCT_FACTS;